/* eslint-disable @typescript-eslint/no-explicit-any */
import { hall } from '@/hall'
import { ModuleBase } from './ModuleBase'
import { MsgIDs } from '@/defines/MsgIDs'
import { base } from '@/base/base'
import { serverErrorMsg } from '@/defines/ServerError'
import { wsClient } from '@/net/WebSocketClient'

export class MailModule extends ModuleBase {
  mailList: any[] = []

  unreadMailCount: number = 0

  init(): void {}

  onClear(): void {
    this.mailList = []
  }
  onLoad(): void {}
  onDestroy(): void {}
  onPreloadData(): void {}

  sendReqEmailCount() {
    const message = {
      UserID: hall.userModule.userId,
    }

    wsClient.send(MsgIDs.Client2ProxyReqGetMailCount, message)
  }

  sendReqMailContent(mailId: number) {
    const message = {
      UserID: hall.userModule.userId,
      MailId: mailId,
    }

    wsClient.send(MsgIDs.Client2ProxyReqGetMailContent, message)
  }

  sendReqMailList() {
    const message = {
      UserID: hall.userModule.userId,
    }

    wsClient.send(MsgIDs.Client2ProxyReqGetMailList, message)
  }

  inits2c(): void {
    ;(hall.s2c as any).onClient2ProxyAckGetMailCount = (msg: any) => {
      if (msg.Ret == 0) {
        this.unreadMailCount = msg.MailCount
        hall.eventDispatcher.emit(hall.EventDefine.UnreadMailCountChange, msg.MailCount)
      } else {
        base.toast(serverErrorMsg(msg.Ret))
      }
    }

    ;(hall.s2c as any).onClient2ProxyAckGetMailContent = (msg: any) => {
      if (msg.Ret == 0) {
        // local messageInfo = {}
        // messageInfo.MailInfoContent = msgTbl.MailInfoContent
        // messageInfo.MailType = msgTbl.MailType
        // messageInfo.SendTime = msgTbl.SendTime
        // self:setMessage(messageInfo)

        hall.eventDispatcher.emit(hall.EventDefine.GetMailContent, msg)
      } else {
        base.toast(serverErrorMsg(msg.Ret))
      }
    }

    ;(hall.s2c as any).onClient2ProxyAckGetMailList = (msg: any) => {
      if (msg.Ret == 0) {
        // self.FirstMailType = msgTbl.FirstMailType
        // self.FirstSendTime = msgTbl.SendTime
        // self.mailListInfo = msgTbl.MailListInfo
        // self:updateLeftTableView()

        this.mailList = msg.MailListInfo

        hall.eventDispatcher.emit(hall.EventDefine.MailListChange)
      } else {
        base.toast(serverErrorMsg(msg.Ret))
      }
    }
  }
}
